import { render, staticRenderFns } from "./askConvert3dTextAlertModal.vue?vue&type=template&id=9837468a&"
import script from "./askConvert3dTextAlertModal.vue?vue&type=script&lang=ts&"
export * from "./askConvert3dTextAlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./askConvert3dTextAlertModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports